import {Subject} from 'rxjs';

import IInteractionPayload from '../../../Analytics/Interactions/Interfaces/IInteractionPayload';
import StoreName           from '../../Shared/Constants/StoreName';
import IPlayerState        from '../../Shared/Interfaces/IPlayerState';

import createFrameActionsResolver from './createFrameActionsResolver';
import Frame                      from './Frame';
import IFrame                     from './Interfaces/IFrame';
import IFrameStore                from './Interfaces/IFrameStore';

const createFrameStore = (
    state: IPlayerState,
    interactions$: Subject<IInteractionPayload>,
    initialValue: IFrame = {}
): IFrameStore => {
    const resolveFrameActions = createFrameActionsResolver(interactions$);

    return state.createStore({
        name: StoreName.FRAME,
        model: Frame,
        actions: resolveFrameActions
    }, initialValue);
};

export default createFrameStore;